'use strict';
// This retirement applies only to the Services collection presentation.
const isRetiredServicesDestination = path => ['/companies', '/companies/apply'].includes(path);
function guardServicesHero(content, fallback) {
  const guarded = { ...content };
  for (const slot of ['primary', 'secondary', 'tertiary']) {
    if (!isRetiredServicesDestination(guarded[slot + 'CtaPath'])) continue;
    guarded[slot + 'CtaLabel'] = slot === 'primary' ? fallback.primaryCtaLabel : '';
    guarded[slot + 'CtaPath'] = slot === 'primary' ? fallback.primaryCtaPath : '';
  }
  return guarded;
}
module.exports = { isRetiredServicesDestination, guardServicesHero };
